import React from 'react';

const Pulse = ({ className = '' }) => (
  <div className={`animate-pulse bg-brand-100 rounded-xl ${className}`} />
);

export const SkeletonStat = () => (
  <div className="bg-white rounded-2xl border border-brand-100 p-5">
    <div className="flex items-center gap-4">
      <Pulse className="w-12 h-12 rounded-xl" />
      <div className="flex-1">
        <Pulse className="h-3.5 w-20 mb-2.5" />
        <Pulse className="h-6 w-28" />
      </div>
    </div>
  </div>
);

export const SkeletonTable = ({ rows = 5, cols = 4 }) => (
  <div className="bg-white rounded-2xl border border-brand-100 overflow-hidden">
    <div className="px-5 py-3.5 border-b border-brand-100 flex gap-4">
      {Array.from({ length: cols }).map((_, i) => (
        <Pulse key={i} className="h-3.5 flex-1" />
      ))}
    </div>
    <div className="divide-y divide-brand-50">
      {Array.from({ length: rows }).map((_, row) => (
        <div key={row} className="px-5 py-4 flex gap-4">
          {Array.from({ length: cols }).map((_, col) => (
            <Pulse key={col} className="h-4 flex-1" />
          ))}
        </div>
      ))}
    </div>
  </div>
);

export const SkeletonCard = () => (
  <div className="bg-white rounded-2xl border border-brand-100 p-4">
    <div className="flex justify-between items-start mb-3">
      <Pulse className="h-5 w-32" />
      <div className="flex gap-2">
        <Pulse className="h-8 w-16 rounded-lg" />
        <Pulse className="h-8 w-16 rounded-lg" />
      </div>
    </div>
    <Pulse className="h-4 w-48 mb-2" />
    <Pulse className="h-3 w-24" />
  </div>
);

export const SkeletonCards = ({ count = 3 }) => (
  <div className="space-y-3">
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonCard key={i} />
    ))}
  </div>
);

export const SkeletonDashboard = () => (
  <div className="space-y-6">
    <div>
      <Pulse className="h-8 w-48 mb-2" />
      <Pulse className="h-5 w-64" />
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <SkeletonStat />
      <SkeletonStat />
      <SkeletonStat />
    </div>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {[1, 2, 3, 4].map(i => (
        <div key={i} className="bg-white rounded-2xl border border-brand-100 p-5">
          <div className="text-center">
            <Pulse className="h-10 w-10 mx-auto mb-3 rounded-xl" />
            <Pulse className="h-4 w-20 mx-auto mb-1.5" />
            <Pulse className="h-3 w-28 mx-auto" />
          </div>
        </div>
      ))}
    </div>
  </div>
);
